import { Button } from "antd"
import { useGetPaymentCollectionLinkQuery } from "../../../domain/invoicing/invoicingQueries"

const AddPaymentMethodButton = ({ customerId }: { customerId: number }) => {
  const { data, isLoading } = useGetPaymentCollectionLinkQuery(customerId)

  if (isLoading || !data?.link) {
    return null
  }

  return (
    <Button type="primary" onClick={() => window.open(data.link, '_blank')}>
      Add Payment Method
    </Button>
  )
}

export default AddPaymentMethodButton
